import { render, staticRenderFns } from "./ExContract.vue?vue&type=template&id=2a12c948&scoped=true&"
import script from "./ExContract.vue?vue&type=script&lang=js&"
export * from "./ExContract.vue?vue&type=script&lang=js&"
import style0 from "./ExContract.vue?vue&type=style&index=0&id=2a12c948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12c948",
  null
  
)

export default component.exports